import { ReactComponent as GearRegularIcon } from "../../assets/icons/gear-regular.svg";
import useBillingStore from "../../stores/billing-store/billing-store";
import getBridges from "../../utils/bridges/get-bridges";
import { isDoctorOnly } from "../../utils/bridges/methods";
import { track } from "../../utils/tracking";
import ClinicSelector from "../queue/clinic-selector";
import { CustomButtonComponent } from "../queue/queue-header";
import TimeFilters from "./time-filters";

export default function PaymentsDashboardTopBar() {
  const { navigate } = getBridges() || {};
  const {
    setPaymentTimelineDuration,
    paymentTimeline,
    paymentGroupFilter,
    clinicId,
    setClinicId,
  } = useBillingStore();

  const handleReceiptConfigClick = () => {
    navigate?.("push", `/app/receipt-config/${clinicId}`);
  };

  return (
    <div className="w-full flex border-b-1 dr-box-border dr-py-12 dr-px-16 dr-border-b-darwin-touch-neutral-200 items-center justify-between">
      <div className="dr-flex dr-items-center space-x-16">
        <div className="Title3Regular dr-text-darwin-touch-neutral-1000">
          Payments
        </div>
        <ClinicSelector
          selectedClinicId={clinicId}
          onClinicChange={(id) => {
            track("payment_clinic_change", {});
            setClinicId({ clinicId: id });
            navigate?.("replace", `/app/payments/${paymentGroupFilter}/${id}`);
          }}
        />
      </div>
      <div className="flex space-x-16">
        <div
          className="flex items-center justify-between cursor-pointer dr-p-6 dr-cursor-pointer dr-bg-darwin-touch-neutral-50 dr-rounded-8"
          onClick={handleReceiptConfigClick}
        >
          <GearRegularIcon className="dr-w-24 dr-h-24 dr-p-4 dr-text-darwin-touch-neutral-1000" />
        </div>

        <TimeFilters
          onClick={({ timeFilter, duration }) => {
            setPaymentTimelineDuration({
              paymentTimeline: timeFilter,
              duration,
            });
          }}
          selectedTimeline={paymentTimeline}
        />
        <CustomButtonComponent />
      </div>
    </div>
  );
}
